import { useState } from 'react';
import * as React from 'react';
import gettext from '@sdk/lang/gettext';

import SurveyScoreStep from '@web/components/survey/surveyScore/SurveyScoreStep';
import SurveyStep from '@web/components/survey/SurveyStep';
import SurveyCommentStep from '@web/components/survey/SurveyCommentStep';
import SurveyFinishStep from '@web/components/survey/SurveyFinishStep';
import BookCall from '@web/components/survey/BookCall';
import { isScorePositive, isBadScore } from '@web/components/psatScore/utils';
import { PsatSteps } from '@web/components/psatScore/types';
import { PSAT_STEPS_CONFIG } from '@web/components/psatScore/psatScore.consts';
import { BOOK_CALL_DEFAULT_SLING_PM } from '@web/constants';

type Props = {
  score: number;
  setScore: (score: number) => void;
  comment1: string;
  setComment1: (comment: string) => void;
  submitForm: VoidFunction;
  close: VoidFunction;
  onPositiveRate: VoidFunction;
};

export const PsatScoreSteps: React.FC<React.PropsWithChildren<Props>> = ({
  score,
  setScore,
  comment1,
  setComment1,
  submitForm,
  onPositiveRate,
  close,
}) => {
  const [step, setStep] = useState(PsatSteps.rate);

  const submitScore = (): void => {
    if (isScorePositive(score)) {
      onPositiveRate();
    }

    setTimeout(() => setStep(PsatSteps.comment1), 300);
  };

  const nextStep = (): void => {
    setStep((step) => {
      let next = step + 1;

      if (next === PsatSteps.finish && isBadScore(score)) {
        next = PsatSteps.finishCall;
      }

      if (next === PsatSteps.finish || PsatSteps.finishCall) {
        submitForm();
      }

      return next;
    });
  };

  if (step === PsatSteps.rate) {
    return <SurveyScoreStep score={score} onSetScore={setScore} submitScore={submitScore} />;
  }

  if (step === PsatSteps.comment1) {
    const currentStep = PSAT_STEPS_CONFIG[PsatSteps.comment1];
    return (
      <SurveyCommentStep
        comment={comment1}
        setComment={setComment1}
        submitStep={nextStep}
        text={gettext(currentStep.text)}
      />
    );
  }

  if (step === PsatSteps.finish) {
    const currentStep = PSAT_STEPS_CONFIG[PsatSteps.finish];
    return (
      <SurveyFinishStep
        title={gettext(currentStep.title)}
        subtitle={gettext(currentStep.subtitle)}
        closeSurvey={close}
      />
    );
  }

  if (step === PsatSteps.finishCall) {
    return (
      <SurveyStep>
        <BookCall bookCallUrl={BOOK_CALL_DEFAULT_SLING_PM} />
      </SurveyStep>
    );
  }

  return null;
};
